export default __webpack_public_path__ + "static/media/rain-3.b9c8b2b4.png";